import { saveNativePasswordCredential } from '../mobile/nativeCredentials'

type PasswordCredentialData = {
  id: string
  password: string
  name?: string
}

type PasswordCredentialConstructor = new (data: PasswordCredentialData) => unknown

type CredentialStore = {
  store: (credential: unknown) => Promise<unknown>
}

type CredentialWindow = Window & {
  PasswordCredential?: PasswordCredentialConstructor
}

type CredentialNavigator = Navigator & {
  credentials?: Partial<CredentialStore>
}

export async function storePasswordCredential({
  email,
  password,
  name,
}: {
  email: string
  password: string
  name?: string
}) {
  const trimmedEmail = email.trim()

  if (!trimmedEmail || !password || typeof window === 'undefined') {
    return
  }

  const savedNatively = await saveNativePasswordCredential({
    email: trimmedEmail,
    password,
  })
  if (savedNatively) {
    return
  }

  const PasswordCredential = (window as CredentialWindow).PasswordCredential
  const credentials = (navigator as CredentialNavigator).credentials

  if (!PasswordCredential || typeof credentials?.store !== 'function') {
    return
  }

  try {
    await credentials.store(
      new PasswordCredential({
        id: trimmedEmail,
        password,
        name: name?.trim() || trimmedEmail,
      })
    )
  } catch {
    // Credential saving is a browser/OS affordance. Auth must never fail because it is unavailable.
  }
}
